import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaLeaf,
  FaCalendarAlt,
  FaClock,
  FaDollarSign,
  FaTractor,
  FaWalking,
  FaDog,
  FaHome,
  FaRecycle,
  FaArrowLeft,
  FaStore,
  FaDoorOpen,
  FaCar,
  FaSchool,
  FaCheckCircle,
} from "react-icons/fa";
import { autoUnlockPending } from "../utils/autoUnlock";
import { API_BASE_URL } from "../config";


const placeholderImage = "/images/Grass.jpg";

const formatDuration = (hours) => {
  if (!hours) return "N/A";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  const hourText = h > 0 ? `${h} hr${h > 1 ? "s" : ""}` : "";
  const minText = m > 0 ? `${m} min${m > 1 ? "s" : ""}` : "";
  return `${hourText}${hourText && minText ? " " : ""}${minText}` || "N/A";
};

function ListingDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  // restore logged user
  const user = JSON.parse(localStorage.getItem("user")) || null;

  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🟢 NEW — Track buy status on screen
  const [buyStatus, setBuyStatus] = useState("available");


  useEffect(() => {
  const fetchListing = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/listings/${id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (!data.success || (!data.listing && !data.listings)) {
  setListing(null);
  return;
}

const l = data.listing || (data.listings ? data.listings[0] : null);


      setListing({
        ...l,
        streetParking: l.streetParking == 1 || l.streetParking === true,
        schoolZone: l.schoolZone == 1 || l.schoolZone === true,
        hasDogs: l.hasDogs == 1 || l.hasDogs === true,
        greenBin: l.greenBin == 1 || l.greenBin === true,
        frontLawn: l.frontLawn == 1 || l.frontLawn === true,
        rearLawn: l.rearLawn == 1 || l.rearLawn === true,
        natureStrip: l.natureStrip == 1 || l.natureStrip === true,
        acreage: l.acreage == 1 || l.acreage === true,
         newClient: l.newClient == 1 || l.newClient === true,
  longTermClient: l.longTermClient == 1 || l.longTermClient === true,
        disclaimerAccepted:
          l.disclaimerAccepted == 1 || l.disclaimerAccepted === true,
      });

      setBuyStatus(l.buy_status || "available");

      autoUnlockPending(l.listingId);

    } catch (err) {
      console.error("❌ Failed to fetch listing:", err);
      setListing(null);
    } finally {
      setLoading(false);
    }
  };

  fetchListing();
}, [id]);



  const getImageSrc = (image) => {
    if (!image) return placeholderImage;
    if (image.startsWith("http") || image.startsWith("/images/")) return image;
    return `/images/${image.split("/").pop()}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-AU", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const openInMaps = () => {
    if (listing?.suburb) {
      const query = `${listing.suburb}+${listing.state}+${listing.postcode}`;
      window.open(
        `https://www.google.com/maps/search/${encodeURIComponent(query)}`,
        "_blank"
      );
    }
  };

  // ============================================
// STRIPE CANCEL CLEANUP (DELETE UNPAID LISTING)
// ============================================
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const cancelled = params.get("payment");

  if (cancelled === "cancel" && listing?.listingId) {
    const token = localStorage.getItem("token");

    fetch(`${API_BASE_URL}/api/listings/cancel/${listing.listingId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        console.log("🗑️ Unpaid listing deleted after Stripe cancel.");
        navigate("/listings"); // send user back
      })
      .catch((err) => {
        console.error("Cancel cleanup failed:", err);
      });
  }
}, [listing, navigate]);


  // ==========================================================
  // 🟢 BUY NOW (LOCK BUTTON + SHOW STATUS)
  // ==========================================================
  const handleBuyNow = async () => {
    try {
      if (!user || !user.id) {
        alert("You must be logged in to purchase.");
        return;
      }

      // 🛑 Block seller from buying their own listing
    if (user?.id === listing?.userId) {
      alert("❌ You cannot buy your own listing.");
      return;
    }

// 🛑 Prevent buying unless listing is active/live
if (!["active", "live"].includes(listing.listing_status)) {
  alert("❌ This listing is not active yet.\nThe seller has not paid the listing activation fee.");
  return;
}


      // 🟢 Immediately show "Buy In Progress" on screen
      setBuyStatus("pending");




      const response = await fetch(
        `${API_BASE_URL}/api/payment/create-checkout-session`,
        {
          method: "POST",
          headers: {
  "Content-Type": "application/json",
 "Authorization": `Bearer ${localStorage.getItem("token")}`

},

          body: JSON.stringify({
            amount: listing.price * 100,
            productName: listing.title,
            listingId: listing.listingId,
            title: listing.title,
            suburb: listing.suburb,
            postcode: listing.postcode,
            frequency: listing.frequency,
            price: listing.price,

            buyerId: user.id,
            sellerId: listing.userId,
            full_snapshot: listing,
          }),
        }
      );

      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error("❌ Payment Error:", error);
      // If error restore button
      
    }
  };

  if (loading)
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loading...</p>;

  if (!listing)
    return (
      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Listing not found.
      </p>
    );

  return (
    <div
      style={{
        maxWidth: "950px",
        margin: "2rem auto",
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      {/* Hero Image */}
      <div style={{ position: "relative" }}>
        <img
          src={getImageSrc(listing.image)}
          alt={listing.title}
          style={{ width: "100%", height: "380px", objectFit: "cover" }}
        />
        <button
          onClick={() => navigate("/listings")}
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "50%",
            padding: "10px",
            cursor: "pointer",
          }}
          title="Back to Listings"
        >
          <FaArrowLeft />
        </button>
      </div>

      <div style={{ padding: "25px" }}>
        <h1 style={{ color: "#2e7d32", marginBottom: "5px" }}>
          {listing.title || "Untitled Listing"}
        </h1>

        <p style={{ color: "#999", margin: "3px 0" }}>
          Listing ID: {listing.listingId}
        </p>

        <p
          style={{ color: "#666", marginBottom: "10px", cursor: "pointer" }}
          onClick={openInMaps}
        >
          <FaMapMarkerAlt style={{ color: "#2e7d32", marginRight: "5px" }} />
          {listing.suburb}, {listing.state} {listing.postcode}
        </p>

        {/* CLIENT OVERVIEW */}
        <Section title="🧍‍♂️ Client Overview" color="#7b1fa2">
          <Info icon={<FaDoorOpen />} label="Access Type" value={listing.accessType} isText />
          <Info icon={<FaCar />} label="Street Parking" value={listing.streetParking} />
          <Info icon={<FaSchool />} label="School Zone" value={listing.schoolZone} />
          <Info icon={<FaDog />} label="Has Dogs" value={listing.hasDogs} />
          <Info icon={<FaRecycle />} label="Green Bin" value={listing.greenBin} />
        </Section>

        {/* SERVICE SUMMARY */}
        <Section title="🧰 Service Summary" color="#4caf50">
          <Info icon={<FaClock />} label="Time per Job" value={formatDuration(Number(listing.time))} isText />
          <Info icon={<FaCalendarAlt />} label="Growing Season Frequency" value={listing.frequency} isText />
          <Info
            icon={listing.rideOnOrPush === "Ride-on" ? <FaTractor /> : <FaWalking />}
            label="Mower Type"
            value={listing.rideOnOrPush}
            isText
          />
          <Info icon={<FaLeaf />} label="Grass Handling" value={listing.bagMulch} isText />
        </Section>

        {/* AREAS */}
        <Section title="🌿 Areas Serviced" color="#43a047">
          <Info icon={<FaHome />} label="Front Lawn" value={listing.frontLawn} />
          <Info icon={<FaLeaf />} label="Rear Lawn" value={listing.rearLawn} />
          <Info icon={<FaMapMarkerAlt />} label="Nature Strip" value={listing.natureStrip} />
          <Info icon={<FaLeaf />} label="Acreage Property" value={listing.acreage} />
        </Section>

        {/* CLIENT HISTORY */}
<Section title="🕒 Client History" color="#8e24aa">
  <Info
    icon={<FaCalendarAlt />}
    label="New Client"
    value={listing.newClient}
  />
  <Info
    icon={<FaCheckCircle />}
    label="Long-Term Client"
    value={listing.longTermClient}
  />
</Section>

        {/* PRICING */}
        <Section title="💰 Pricing & Value" color="#ff9800">
          <Info icon={<FaDollarSign />} label="Cut Value" value={listing.cutValue ? `$${listing.cutValue}` : "N/A"} isText />
          <Info icon={<FaDollarSign />} label="Sale Price" value={listing.price ? `$${listing.price}` : "N/A"} isText />
        </Section>

        {/* VERIFICATION */}
        <Section title="✅ Listing Verification" color="#388e3c">
          <Info icon={<FaCheckCircle />} label="Posted On" value={formatDate(listing.createdAt)} isText />
          {listing.disclaimerAccepted && (
            <Info
              icon={<FaCheckCircle />}
              label="Disclaimer"
              value="Seller confirmed this listing is genuine."
              isText
            />
          )}
        </Section>

      {/* BUTTONS */}
<div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
  {/* 🟢 BUY NOW BUTTON WITH STATUS */}
  <button
    onClick={handleBuyNow}
    disabled={buyStatus !== "available"}
    style={buttonStyle(
      buyStatus === "available" ? "#0288d1" : "#999"
    )}
  >
    <FaStore style={{ marginRight: "6px" }} />
    {buyStatus === "available" && "Buy Listing"}
    {buyStatus === "pending" && "Buy In Progress…"}
    {buyStatus === "sold" && "Sold"}
  </button>
</div>

      </div>
    </div>
  );
}

/* Helper Components */

const Section = ({ title, color, children }) => (
  <section style={{ marginTop: "25px" }}>
    <h2 style={{ borderBottom: `2px solid ${color}`, paddingBottom: "5px" }}>
      {title}
    </h2>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "15px",
        marginTop: "10px",
      }}
    >
      {children}
    </div>
  </section>
);

const Info = ({ icon, label, value, isText = false }) => {
  let displayValue = value;

  if (typeof value === "boolean") displayValue = value ? "Yes" : "No";
  if (value === 1 || value === 0) displayValue = value === 1 ? "Yes" : "No";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#f9f9f9",
        borderRadius: "8px",
        padding: "10px 12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        gap: "10px",
      }}
    >
      <div style={{ fontSize: "1.2rem", color: "#4caf50" }}>{icon}</div>
      <div>
        <div style={{ fontWeight: "bold", color: "#333" }}>{label}</div>
        <div style={{ color: "#2e7d32" }}>{isText ? value : displayValue}</div>
      </div>
    </div>
  );
};

const buttonStyle = (bg) => ({
  flex: 1,
  padding: "12px",
  backgroundColor: bg,
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  transition: "all 0.2s ease",
});

export default ListingDetails;
